import React from 'react';
import { IconFileText, IconFilter, IconPlus } from '../../icons';
import GrupoDeAbasDeDemandas from '../GrupoDeAbasDeDemandas';
import {
  Container,
  LeftSection,
  RightSection,
  TitleSection,
  MainTitle,
  ActionButton,
  PrimaryButton,
  ButtonGroup,
  RelatorioButton,
  BadgeCount,
  TopHeader,
  HeaderContainer
} from './styles';
import { useAuth } from '../../../contexts/UserContext';
import { useHistory } from 'react-router-dom';

interface CabecalhoListaDemandaProps {
  emiteRelatorio?: () => void;
  alteraStatusFiltro?: () => void;
  grupoAbas?: React.ReactNode;
  quantidadeFiltrosAtivos?: number;
}

export default function CabecalhoListaDemanda({
  emiteRelatorio = () => {},
  alteraStatusFiltro = () => {},
  grupoAbas,
  quantidadeFiltrosAtivos = 0
}: CabecalhoListaDemandaProps) {

  const { user } = useAuth();
    const history = useHistory();

  const handleNovo = () => {
    history.push('/Nova-Demanda');

  };

  const handleRelatorio = () => {
    emiteRelatorio();
  };

  const handleFiltros = () => {
    alteraStatusFiltro();
  };

  return (
    <HeaderContainer>

      <TopHeader>
        <LeftSection>
          <TitleSection>
            <MainTitle>Demandas</MainTitle>
          </TitleSection>
        </LeftSection>

        <RightSection>
          <ButtonGroup>
            {user.profile !== 'comum' && (
              <PrimaryButton 
                onClick={handleNovo}
                title="Criar demanda">
                <IconPlus />
                Novo
              </PrimaryButton>
            )}

            {user.profile !== 'comum' && user.profile !== 'Solicitante' && (
              <RelatorioButton 
                onClick={handleRelatorio}
                title="Gerar relatório">
                <IconFileText />
                Relatório
              </RelatorioButton>
            )}

            <ActionButton onClick={handleFiltros}>
              <IconFilter />
              Filtros
              {quantidadeFiltrosAtivos > 0 && (
                <BadgeCount>{quantidadeFiltrosAtivos}</BadgeCount>
              )}
            </ActionButton>
          </ButtonGroup>
        </RightSection>
      </TopHeader>

      <Container>
        {grupoAbas}
      </Container>
    </HeaderContainer>
  );
}
